// @flow

import { createSelector } from 'reselect';

import { contactbook } from '@gandi/redux-resource-contactbook';
import type { FavoriteContact } from '@gandi/redux-resource-contactbook';

import type { FullState } from '../../../../types';

export const selectContacts: (
  state: FullState,
  orgId: string,
  // $FlowFixMe[incompatible-call]
) => Array<FavoriteContact> = createSelector(
  [contactbook.selectContactsById],
  contactsById => Object.values(contactsById),
);
